// extracted by mini-css-extract-plugin
export default {"navbar__btn":"MainButton_navbar__btn__L66f5"};